export default "__VITE_ASSET__DVWQWqBE__"